import axios from "axios";
import {
  getStoredToken,
  getToken,
  getStoredUserToken,
  refreshUserToken,
  hasLoggedUser,
} from "./authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const base_application_url = process.env.REACT_APP_APPLICATION;

api.interceptors.request.use(async (config) => {
  config.headers["X-source-application"] = base_application_url;
  if (hasLoggedUser()) {
    let user = getStoredUserToken();

    if (!user) {
      const newToken = await refreshUserToken();

      if (newToken) {
        config.headers.Authorization = `Bearer ${newToken}`;
        return config;
      }
    } else {
      config.headers.Authorization = `Bearer ${user.token}`;
      return config;
    }
  }
  let token = getStoredToken();

  if (!token) {
    token = await getToken();
  }

  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    const status = error.response?.status;

    if (
      (status === 401 || status === 403) &&
      !originalRequest._retry &&
      hasLoggedUser()
    ) {
      originalRequest._retry = true;

      const newToken = await refreshUserToken();

      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return api(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default api;

/* import axios from "axios";
import {
  getStoredToken,
  getToken,
  getStoredUserToken,
  refreshUserToken,
} from "./authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
const base_application_url = process.env.REACT_APP_APPLICATION;

api.interceptors.request.use(async (config) => {
  const user = getStoredUserToken();

  config.headers["X-source-application"] = base_application_url;

  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
    config._isUserRequest = true;
    return config;
  }

  let token = getStoredToken();

  if (!token) {
    token = await getToken();
  }

  config.headers.Authorization = `Bearer ${token}`;
  config._isUserRequest = false;

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    if (
      (status === 401 || status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Global token expired
      if (!originalRequest._isUserRequest) {
        const newGlobalToken = await getToken();

        if (newGlobalToken) {
          originalRequest.headers.Authorization = `Bearer ${newGlobalToken}`;
          return api(originalRequest);
        }

        return Promise.reject(error);
      }

      // User token expired
      const newUserToken = await refreshUserToken();

      if (newUserToken) {
        originalRequest.headers.Authorization = `Bearer ${newUserToken}`;
        return api(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
 */